import ModuleTextList from './ModuleTextList';

export default ModuleTextList;
export * from './ModuleTextList';
